/* eslint-disable import/prefer-default-export */
import { Shell as ActionTypes } from '../actionTypes'
import type { State } from '../configureStore'
import type { ResourceTypeDict } from '../reducers/shell'
import * as ReduxHelpers from '@src/utils/reduxHelpers'
import type { ResourceInfo } from '@src/endpoints/services/base.service'
import { PolicyReader } from '@src/endpoints/services/policyReader.service'
import mapToDictionary from '@src/utils/dictionary'
import { defaultHandleStatus } from '@src/endpoints/helpers'
import { capitalize, isEmpty } from 'lodash'
import Pluralizer from '@src/utils/pluralize'
import { AppStorage } from '@src/utils/storage.helpers'
import { storagePrefix } from '@src/constants/constants'
import { parseResourceTypeName } from '@src/utils/text.utils'
import { getFeatureFlagAsync } from '@src/endpoints/feature.flag'

const storage = new AppStorage(storagePrefix, sessionStorage)

const pluralizer = new Pluralizer()
pluralizer.addPluralRule(/VPC$/i, 'VPCs')

// Action Creators

export type ActionTypes =
  | getResourceTypesAction
  | cleanerResourceTypesAction
  | setStatusSSOAction
  | setUseIDNLoginPathFlag
  | setTexBoxTooltipFixFlag

export const getResourceTypes = (types: ResourceTypeDict) =>
  ReduxHelpers.Actions.createPayloadAction(
    ActionTypes.GET_SUPPORTED_RESOURCE_TYPES_SUCCESS,
    { types, isPending: false }
  )
export type getResourceTypesAction = ReturnType<typeof getResourceTypes>

export const cleanerResourceTypes = () =>
  ReduxHelpers.Actions.createAction(
    ActionTypes.CLEANER_SUPPORTED_RESOURCE_TYPES
  )
type cleanerResourceTypesAction = ReturnType<typeof cleanerResourceTypes>

export const setStatusSSO = (flag: boolean) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.SET_STATUS_SSO, {
    flag
  })

type setStatusSSOAction = ReturnType<typeof setStatusSSO>

export function getLabelType(options: ResourceInfo) {
  if (
    options?.display_name &&
    options?.display_name !== options?.resource_name
  ) {
    return options.display_name
  }
  let objectTypeWords: string[] = options.resource_name.split('_')
  objectTypeWords = objectTypeWords.map(w => capitalize(w))
  return objectTypeWords.join(' ')
}

export const fetchUseIDNPathFlag =
  () => (dispatch: any, getStore: () => State) => {
    getFeatureFlagAsync('CAM_TEMP_20220623_IDN_LOGIN_PATH', {
      signal: null
    }).then(res => {
      dispatch(setUseIDNLoginPath(res?.value ?? false))
    })
  }

export const fetchTexBoxTooltipFixFlag =
  () => (dispatch: any, getStore: () => State) => {
    getFeatureFlagAsync('CAM_TEMP_20221114_INPUT_TOOLTIP_FIX', {
      signal: null
    }).then(res => {
      dispatch(setTexBoxTooltipFixState(res?.value ?? false))
    })
  }

export const setUseIDNLoginPath = (useIDNLoginPath: boolean) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.SET_USE_IDN_PATH_FLAG, {
    useIDNLoginPath
  })
type setUseIDNLoginPathFlag = ReturnType<typeof setUseIDNLoginPath>

export const setTexBoxTooltipFixState = (flagState: boolean) =>
  ReduxHelpers.Actions.createPayloadAction(
    ActionTypes.SET_TEXTBOX_TOOLTIP_FIX_FLAG,
    { useTexBoxTooltipFix: flagState }
  )
type setTexBoxTooltipFixFlag = ReturnType<typeof setTexBoxTooltipFixState>

// Action Creators

export function getSupportedResourceTypes() {
  return (dispatch: any, getStore: () => State) => {
    dispatch(cleanerResourceTypes())
    const oauthToken: string = storage.get('oauthToken')
    if (!isEmpty(oauthToken)) {
      PolicyReader.GetResourceTypeEnum({
        params: {},
        options: { signal: null }
      })
        .then(res => defaultHandleStatus(res, null, true))
        .then(res => {
          const types = mapToDictionary({
            array: res.resource_info || [],
            key: 'resource_name',
            iterator: x => {
              const display_name = capitalize(getLabelType(x))
              return {
                ...x,
                display_name: display_name.toUpperCase(),
                display_name_plural: parseResourceTypeName(
                  pluralizer.pluralize(display_name)
                )
              }
            }
          })
          dispatch(getResourceTypes(types as ResourceTypeDict))
        })
        .catch(ex => ex)
    }
  }
}
